import { useCallback, useEffect, useState } from "react";

import { adminApi, buildQuery } from "../services/adminApi";

export default function useDashboard(filters) {
  const [dashboard, setDashboard] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const loadDashboard = useCallback(async () => {
    setIsLoading(true);
    setError("");

    try {
      const payload = await adminApi(`/dashboard/${buildQuery(filters)}`);
      setDashboard(payload);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setIsLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    loadDashboard();
  }, [loadDashboard]);

  return {
    dashboard,
    error,
    isLoading,
    reloadDashboard: loadDashboard,
  };
}